'use client';

import { useTrackingUuid } from '@sortlist-frontend/tracking';
import { GTMProps } from '@sortlist-frontend/user-tools';
import { isAutomation } from '@sortlist-frontend/utils';
import dynamic from 'next/dynamic';

const GoogleTagManager = dynamic(
  () => import('@sortlist-frontend/user-tools').then((mod) => ({ default: mod.GoogleTagManager })),
  { ssr: false },
);

type PublicGTMProps = Omit<GTMProps, 'userInfo'> & {
  userInfo?: GTMProps['userInfo'];
};

export const PublicGoogleTagManager = (props: PublicGTMProps) => {
  const { userInfo = {} } = props;
  const { sessionUuid } = useTrackingUuid();
  if (isAutomation()) return;
  return <GoogleTagManager userInfo={{ ...userInfo, userId: sessionUuid }} />;
};
